import React, {useState, useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faPhone} from '@fortawesome/free-solid-svg-icons';


function Form({rock}) {
const [name, setName] = useState()
const [email, setEmail] = useState()
const [location, setLocation] = useState()
const [phone, setPhone] = useState()
const [altnum, setAlt] = useState()
const [rev, setReviews] = useState()
const [checked, setCheck] = useState('no')
const [checkval, setCheckval] = useState(true)
const [loading, setLoading] = useState(false)

const yes =()=>{
   setCheck('yes')
   setCheckval(false)
}

const no =()=>{
  setCheck('no')
  setCheckval(false)
}

const sub = () =>{
  if (name && email && location && phone && altnum && checked) {

    const loginData = {
       name: name,
       email: email,
       location: location,
       phone: phone,
       altnum: altnum,
       rev: rev,
       checked: checked
     
      };

            // Send data to the PHP backend using fetch
            fetch('https://hosteladventures.site/PHP/Guidance.php', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(loginData)
            })
              .then(response => response.json())
              .then(data => {
                // Handle response from backend (e.g., login success or failure)
                if(data.message=='in')
                {
                  rock(false)
                  alert('Submission Successful!!')
                }
             
              })
              .catch(error => {
                console.error('Error:', error);
              });
    
  } else {
    alert('Please fill in all the inputs.')
  }
}

  return (
    <div className='Form_GDC'>
    <p className='fill_In'>Fill In</p>
        <input placeholder='Name of applicant' onChange={(event) => setName(event.target.value)} />
        <input placeholder='email' onChange={(event) => setEmail(event.target.value)} />
        <input placeholder='Location' onChange={(event) => setLocation(event.target.value)} />
        <input placeholder='Phone Number' onChange={(event) => setPhone(event.target.value)}/>
        <input placeholder='Aternative Phone Number' onChange={(event) => setAlt(event.target.value)} />
        <textarea className='textAr' placeholder='write reviews' onChange={(event) => setReviews(event.target.value)}/>
        <div className='whts'><FontAwesomeIcon icon={faPhone} /> Click to Talk to us on Whatsapp</div>

        <div className='checkBox'>
          <div className='career_quiz'>Career Councling? (optional)</div> 
          {checkval?(<div className='btn_cb'><button onClick={yes}>yes</button> <button onClick={no}>no</button></div>):('')}
          
          </div>
    
       {!loading?(<div className='submit' onClick={sub}>Submit</div>):(<div className='submit'>Submitting...</div>)}
        
        
        
    </div>
  )
}

export default Form
